jQuery( document ).ready( function ( $ ) {
	class MINIMODAL {
		static version = 'V1.0.0'
		static blockName = 'Gutenberg Minimodal'
		static activeClass = 'jtf__minimodal--modal--active'

		constructor( context ) {
			this.context = context
			this.trigger = context.find( '.jtf__minimodal--modal--trigger--button' )
			this.close = context.find( '.jtf__minimodal--modal--close--button' )
			this.modalContent = context.find( '.jtf__minimodal--modal--content' )

			this.clickMapping()
			this.debug( false )
		}

		debug( state ) {
			if ( state ) {
				console.log( `[JTF Gut Block - JS] ${ MINIMODAL.blockName } ${ MINIMODAL.version }` )
				console.log( `${ MINIMODAL.blockName } context:`, this.context )
			}
		}

		clickMapping() {
			this.trigger.on( 'click', () => {
				const action = this.trigger.hasClass( MINIMODAL.activeClass ) ? 'removeClass' : 'addClass'
				this.modalContent[ action ]( MINIMODAL.activeClass )
				this.trigger[ action ]( MINIMODAL.activeClass )

				if ( action === 'addClass' ) {
					this.modalContent.focus()
					this.trapFocus()
				} else {
					this.releaseFocus()
				}
			} )

			this.close.on( 'click', () => {
				this.modalContent.removeClass( MINIMODAL.activeClass )
				this.trigger.removeClass( MINIMODAL.activeClass )
				this.trigger.focus()
				this.releaseFocus()
			} )


			this.modalContent.on( 'keydown', ( e ) => {
				if ( e.key === 'Escape' ) {
					this.modalContent.removeClass( MINIMODAL.activeClass )
					this.trigger.removeClass( MINIMODAL.activeClass )
					this.trigger.focus()
					this.releaseFocus()
				}
			} )
		}

		trapFocus() {
			const focusableElements = this.modalContent.find( 'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])' )
			const firstElement = focusableElements.first()
			const lastElement = focusableElements.last()

			this.modalContent.on( 'keydown', ( e ) => {
				if ( e.key === 'Tab' ) {
					if ( e.shiftKey ) {
						if ( document.activeElement === firstElement[ 0 ] ) {
							e.preventDefault()
							lastElement.focus()
						}
					} else {
						if ( document.activeElement === lastElement[ 0 ] ) {
							e.preventDefault()
							firstElement.focus()
						}
					}
				}
			} )
		}

		releaseFocus() {
			this.modalContent.off( 'keydown' )
		}
	}

	$( '.jtf__minimodal' ).each( ( _, element ) => {
		new MINIMODAL( $( element ) )
	} )
} )